import React from "react";
import Popup from 'reactjs-popup';
import './AddProject.css';
import 'reactjs-popup/dist/index.css';
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Row,
    Col,
    Button,
  } from "reactstrap";


function AddProject(props) {

    function addProject(close){
        var url = document.getElementById("urlInput").value;
        var label = document.getElementById("labellInput").value;
        if(url === ""){
            alert("Please fill in all fields.");
            return;
        }
        props.onClickAddProject(url, label);
        close();
    }

    function closeModal(close){
        close();
    }

    return (
        <div style={{textAlign:"center", display:"flex", justifyContent:"space-evenly"}}>

                <Popup trigger={<Button id="addProject" style={{margin:"auto", backgroundColor:"rgb(17 159 80)"}}> + </Button>} modal nested>

                {close => (
                    <div className="modal">
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                        <div className="header"> Add New Project </div>
                        <div className="content">
                            {' '}
                            <input type="text" id="urlInput" placeholder="URL" size="40" style={{margin:"auto", display:"block", width:"100%"}}></input>
                            <input type="text" id="labellInput" placeholder="Refactoring Label (not required)" size="20" style={{margin:"auto", display:"block", marginTop:"5px", width:"60%"}}></input>
                            <div style={{display:"flex", justifyContent:"center", marginTop:"5px"}}>
                                <Button id="addButton" onClick={()=>addProject(close)} style={{marginRight:"5px", backgroundColor:"rgb(17 159 80)"}}>Add</Button>
                                <Button id="cancelButton" onClick={()=>closeModal(close)} style={{marginLeft:"5px", backgroundColor:"rgb(239 129 87)"}}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                )}
                </Popup>

        </div>
    );
}

export default AddProject;